import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { createContext, memo } from "react";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { useComponentClassName } from "../../auxiliary/useComponentClassName.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { FieldContainer } from "../Forms/FieldContainer/FieldContainer.js";
import { Box } from "../Box/Box.js";
const UseTableElementContext = createContext(true);
const Table = memo(({ bare, className: classNameProp, ...props }) => {
  const prefix = useClassNamePrefix();
  const componentClassName = useComponentClassName("table");
  const className = classNames(
    componentClassName,
    toEnumViewClass(props.size),
    toEnumViewClass(props.justification, "justifyStart"),
    classNameProp
  );
  const table = /* @__PURE__ */ jsx("div", { className: `${prefix}table-wrapper`, children: /* @__PURE__ */ jsxs("table", { className, children: [
    props.tableHead && /* @__PURE__ */ jsx("thead", { children: props.tableHead }),
    /* @__PURE__ */ jsx("tbody", { children: props.children })
  ] }) });
  return /* @__PURE__ */ jsx(UseTableElementContext.Provider, { value: true, children: /* @__PURE__ */ jsx(FieldContainer, { className: `${componentClassName}-container`, label: !bare && props.heading, useLabelElement: false, children: /* @__PURE__ */ jsx(Box, { padding: "no-padding", className: `${componentClassName}-container-box`, children: table }) }) });
});
Table.displayName = "Table";
export {
  Table,
  UseTableElementContext
};
//# sourceMappingURL=Table.js.map
